import React, { Fragment, useRef } from 'react'
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { RecordRTCPromisesHandler } from 'recordrtc';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import StopCircleIcon from '@mui/icons-material/StopCircle';


const TFAudioRecorder = ( { setBlob } ) => {
    const refAudio = useRef(null);
    const recorderRef = useRef(null);
    
    const handleRecording = async () => {
        const stream = await navigator.mediaDevices.getUserMedia( { audio: true } );
        recorderRef.current = new RecordRTCPromisesHandler( stream, { type: 'audio' } );
        await recorderRef.current.startRecording();
        recorderRef.current.stream = stream;

        refAudio.current.srcObject = stream;
        refAudio.current.muted = true;
        refAudio.current.volume = 0;
    };
    
    const handleStop = async () => {
        await recorderRef.current.stopRecording();
        
        refAudio.current.srcObject = null;
        refAudio.current.muted = false;
        refAudio.current.volume = 1;

        const b = await recorderRef.current.getBlob();
        refAudio.current.src = URL.createObjectURL( b );
        setBlob( b );
        
        // recorderRef.current.stream.getTracks( t => t.stop() );
        await recorderRef.current.reset();
        await recorderRef.current.destroy();
    };
    
    return (
        <Row className='py-3 align-items-center'>
            <Col xs='auto'>
                <audio controls autoPlay playsInline ref={refAudio} />
            </Col>
            <Col xs='auto'>
                <Button variant='link' size='sm' style={ { color: 'red' } } onClick={ handleRecording }><RadioButtonCheckedIcon /></Button>
                <Button variant='link' size='sm' onClick={ handleStop }><StopCircleIcon /></Button>
            </Col>
        </Row>
    )
}
  
export default TFAudioRecorder;